import React, { useEffect, useState } from "react";
import {
  CrudForm,
  Autocomplete,
  FormApi,
  DatePicker,
  MountEntity,
  autocompleteHelpers,
  loopback,
  crudFormEnums,
  SimpleFormDialog,
  SimpleDialog,
} from "elentari";
import Grid from "@material-ui/core/Grid";
import moment from "moment";
import { TextField } from "final-form-material-ui";
import { Field } from "react-final-form";
import { clienteApi, antropometriaApi } from "../../services/Api";
import SendIcon from "@material-ui/icons/Send";
import { getFcmAfterLoad } from "../Fcm/getFcmAfterLoad";
import { getUTCFormatedDate } from "../../utils/dateParse";

const { toOption } = autocompleteHelpers;
const { loopbackFilters } = loopback;

const loadClientes = async (inputValue) => {
  const response = await clienteApi.getList({
    where: {
      nome: loopbackFilters.regexp(inputValue),
    },
    order: "nome asc",
    limit: 40,
  });
  if (response.ok) {
    return response.data.map(toOption("nome"));
  }
  return [];
};

export default function AntropometriaForm(props) {
  const [statusNotificacao, setStatusNotificacao] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [errorOnSendMessage, setErrorOnSendMessage] = useState(false);
  const FCMUtils = getFcmAfterLoad();

  const fetchAntropometria = async () => {
    if (props.match.params.id === "new") {
      setStatusNotificacao(false);
      return;
    }

    const response = await antropometriaApi.getOne(props.match.params.id);

    if (response.ok) setStatusNotificacao(response.data.notificado);
  };

  useEffect(() => {
    fetchAntropometria();
  }, []);

  const getItemDecorator = async ({ getItem, filter }) => {
    if (props.showClient) {
      const result = await MountEntity(props, antropometriaApi.getOne)
        .populate(({ data, id }) => ({
          cliente: clienteApi.getOne(data.clienteId),
        }))
        .clean(["clienteId"])
        .map((data) => ({
          ...data,
          cliente: toOption("nome")(data.cliente),
          dataCadastro: getUTCFormatedDate(data.dataCadastro),
        }))
        .getItem();
      FCMUtils.getClientFcmById(result.cliente.id);
      return result.id ? result : { dataCadastro: moment().format() };
    }
    return getItem(filter);
  };

  const submitDecorator = async ({ id, data, handleSubmit }) => {
    const result = await handleSubmit({
      id,
      data: {
        ...data,
        clienteId: props.showClient
          ? data.cliente.id
          : Number(props.match.params.id),
        cliente: undefined,
        dataCadastro: data.dataCadastro,
        bracoDireitoRelaxado: data.bracoDireitoRelaxado
          ? +data.bracoDireitoRelaxado
          : undefined,
        bracoDireitoContraido: data.bracoDireitoContraido
          ? +data.bracoDireitoContraido
          : undefined,
        antebracoDireito: data.antebracoDireito
          ? +data.antebracoDireito
          : undefined,
        bracoEsquerdoRelaxado: data.bracoEsquerdoRelaxado
          ? +data.bracoEsquerdoRelaxado
          : undefined,
        bracoEsquerdoContraido: data.bracoEsquerdoContraido
          ? +data.bracoEsquerdoContraido
          : undefined,
        antebracoEsquerdo: data.antebracoEsquerdo
          ? +data.antebracoEsquerdo
          : undefined,
        toraxRelaxado: data.toraxRelaxado ? +data.toraxRelaxado : undefined,
        toraxInspirado: data.toraxInspirado ? +data.toraxInspirado : undefined,
        abdomen: data.abdomen ? +data.abdomen : undefined,
        quadril: data.quadril ? +data.quadril : undefined,
        cintura: data.cintura ? +data.cintura : undefined,
        coxaDireita: data.coxaDireita ? +data.coxaDireita : undefined,
        panturrilhaDireita: data.panturrilhaDireita
          ? +data.panturrilhaDireita
          : undefined,
        coxaEsquerda: data.coxaEsquerda ? +data.coxaEsquerda : undefined,
        panturrilhaEsquerda: data.panturrilhaEsquerda
          ? +data.panturrilhaEsquerda
          : undefined,
      },
    });
    return result;
  };

  const validate = (values) => ({
    dataCadastro: values.dataCadastro ? undefined : "Obrigatório",
    cliente: !props.showClient || values.cliente ? undefined : "Obrigatório",
  });

  const enviarNotificacao = async (title, body) => {
    const id = props.match.params.id;
    const response = await antropometriaApi.notify(id, { title, body });
    if (!response.ok) setErrorOnSendMessage(true);
  };

  const customActions = [
    {
      label: statusNotificacao ? "Notificar novamente" : "Notificar",
      icon: <SendIcon style={{ marginLeft: 10 }} />,
      onClick: () => setDialogOpen(true),
      pristine: crudFormEnums.PRISTINE_BEHAVIOR.DISABLED_WHEN_DIRTY,
    },
  ];

  return (
    <div>
      <FormApi
        {...props}
        getItemDecorator={getItemDecorator}
        initialData={{ dataCadastro: moment().format() }}
        submitDecorator={submitDecorator}
        api={antropometriaApi}
      >
        {({ handleSubmit, getItem }) => (
          <CrudForm
            withPaper={props.withPaper}
            validate={validate}
            history={props.history}
            getItem={getItem}
            customActions={props.match.params.id !== "new" ? customActions : []}
            onSubmit={handleSubmit}
          >
            <Grid container direction="column" spacing={16}>
              <Grid item>
                <Grid container spacing={16}>
                  {props.showClient && (
                    <Grid item sm={9} xs={12}>
                      <Field
                        label="Cliente"
                        loadOptions={loadClientes}
                        component={Autocomplete}
                        name="cliente"
                      />
                    </Grid>
                  )}
                  <Grid item sm={3} xs={12}>
                    <Field
                      fullWidth
                      label="Data"
                      component={DatePicker}
                      name="dataCadastro"
                    />
                  </Grid>
                  <Grid item sm={4} xs={12}>
                    <Field
                      type="number"
                      fullWidth
                      autoFocus
                      component={TextField}
                      label="Braço Direito Relaxado"
                      name="bracoDireitoRelaxado"
                    />
                  </Grid>
                  <Grid item sm={4} xs={12}>
                    <Field
                      type="number"
                      fullWidth
                      component={TextField}
                      label="Braço Direito Contraído"
                      name="bracoDireitoContraido"
                    />
                  </Grid>
                  <Grid item sm={4} xs={12}>
                    <Field
                      type="number"
                      fullWidth
                      component={TextField}
                      label="Antebraço Direito"
                      name="antebracoDireito"
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Grid container spacing={16}>
                  <Grid item sm={4} xs={12}>
                    <Field
                      type="number"
                      fullWidth
                      component={TextField}
                      label="Braço Esquerdo Relaxado"
                      name="bracoEsquerdoRelaxado"
                    />
                  </Grid>
                  <Grid item sm={4} xs={12}>
                    <Field
                      type="number"
                      fullWidth
                      component={TextField}
                      label="Braço Esquerdo Contraído"
                      name="bracoEsquerdoContraido"
                    />
                  </Grid>
                  <Grid item sm={4} xs={12}>
                    <Field
                      type="number"
                      fullWidth
                      component={TextField}
                      label="Antebraço Esquerdo"
                      name="antebracoEsquerdo"
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Grid container spacing={16}>
                  <Grid item sm={6} xs={12}>
                    <Field
                      type="number"
                      fullWidth
                      component={TextField}
                      label="Tórax Relaxado"
                      name="toraxRelaxado"
                    />
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <Field
                      type="number"
                      fullWidth
                      component={TextField}
                      label="Tórax Inspirado"
                      name="toraxInspirado"
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Grid container spacing={16}>
                  <Grid item sm={4} xs={12}>
                    <Field
                      type="number"
                      fullWidth
                      component={TextField}
                      label="Cintura"
                      name="cintura"
                    />
                  </Grid>
                  <Grid item sm={4} xs={12}>
                    <Field
                      type="number"
                      fullWidth
                      component={TextField}
                      label="Abdômen"
                      name="abdomen"
                    />
                  </Grid>
                  <Grid item sm={4} xs={12}>
                    <Field
                      type="number"
                      fullWidth
                      component={TextField}
                      label="Quadril"
                      name="quadril"
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Grid container spacing={16}>
                  <Grid item sm={3} xs={12}>
                    <Field
                      type="number"
                      fullWidth
                      component={TextField}
                      label="Coxa Direita"
                      name="coxaDireita"
                    />
                  </Grid>
                  <Grid item sm={3} xs={12}>
                    <Field
                      type="number"
                      fullWidth
                      component={TextField}
                      label="Panturrilha Direita"
                      name="panturrilhaDireita"
                    />
                  </Grid>
                  <Grid item sm={3} xs={12}>
                    <Field
                      type="number"
                      fullWidth
                      component={TextField}
                      label="Coxa Esquerda"
                      name="coxaEsquerda"
                    />
                  </Grid>
                  <Grid item sm={3} xs={12}>
                    <Field
                      type="number"
                      fullWidth
                      component={TextField}
                      label="Panturrilha Esquerda"
                      name="panturrilhaEsquerda"
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Field
                    fullWidth
                    component={TextField}
                    multiline
                    rowsMax={3}
                    label="Observações"
                    name="observacoes"
                  />
                </Grid>
              </Grid>
            </Grid>
          </CrudForm>
        )}
      </FormApi>
      <SimpleFormDialog
        title="Notificar"
        open={dialogOpen}
        buttonLabel="Cancelar"
        primaryAction={(title, body) =>
          enviarNotificacao(title, body).then(fetchAntropometria)
        }
        primaryActionButtonLabel="Enviar"
        firstFormLabel="Título"
        firstDefaultValue="Avaliação"
        secondFormLabel="Mensagem"
        secondDefaultValue="Sua avaliação está disponível!"
        disabledText={FCMUtils.state}
        handleClose={() => {
          setDialogOpen(false);
          fetchAntropometria();
        }}
      />
      <SimpleDialog
        title="Atenção"
        message="Ocorreu um erro no envio da mensagem, por favor tente novamente mais tarde."
        open={errorOnSendMessage}
        primaryActionButtonLabel="Ok"
        handleClose={() => setErrorOnSendMessage(null)}
      />
    </div>
  );
}
